import React, { useState } from "react";
import UnblockAcademic from "./UnblockAcademic";
import ZoomPasswords from "./ZoomPasswords";
import PaceExpediente from "./PaceExpediente";
import InitializeCounters from "./InitializeCounters";
import TabContent from "../ComponentV2/TabContent_register";
import TabNavItem from "../ComponentV2/TabNavItem_admin";
import "./batch_render.css";

const Batch_render = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div className="tabs-batch">
      <ul className="nav-batch">
        <TabNavItem
          title="Desbloqueo académico"
          id="tab1"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Contraseñas Zoom"
          id="tab2"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Expediente PACE"
          id="tab3"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Inicializar contadores"
          id="tab4"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </ul>
      <div className="outlet-batch">
        <TabContent id="tab1" activeTab={activeTab}>
          <UnblockAcademic />
        </TabContent>
        <TabContent id="tab2" activeTab={activeTab}>
          <ZoomPasswords />
        </TabContent>
        <TabContent id="tab3" activeTab={activeTab}>
          <PaceExpediente />
        </TabContent>
        <TabContent id="tab4" activeTab={activeTab}>
          <InitializeCounters />
        </TabContent>
      </div>
    </div>
  );
};

export default Batch_render;
